module.exports = __webpack_public_path__ + "2d231d243310e0ae3e1cb722800bf6cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/intro-panel-texture-420.jpg
// module id = 413
// module chunks = 0